module.exports = __webpack_public_path__ + "img/oyald-collage.9b98f272.jpeg";